// extracted by mini-css-extract-plugin
var _1 = "RewardsTableStyles-module__axisYLabel___qQgPE";
var _2 = "RewardsTableStyles-module__chartWrapper___ESAGy";
var _3 = "RewardsTableStyles-module__tableWrapper___lqX0m";
export { _1 as "axisYLabel", _2 as "chartWrapper", _3 as "tableWrapper" }
